module.exports = __webpack_public_path__ + "media/icons/pierwszy-wlasciciel@2x-33e5b24c.png";